import React, { FC, HTMLAttributes } from "react";
import styled from "styled-components";

export const EnclosurePc: FC<HTMLAttributes<HTMLDivElement>> = ({ children, ...props }) => {
  return (
    <Root {...props}>
      <FrameTop>
        <TopLine />
        <TopDiagonalLine />
        <RightLine />
      </FrameTop>
      <FrameBottom>
        <LeftLine />
        <BottomDiagonalLine />
        <BottomLine />
      </FrameBottom>
      {children}
    </Root>
  );
};

const Root = styled.div`
  position: relative;
  padding: 20px 0;
  color: #fff;
  font-size: 14px;
  @media screen and (max-width: 960px) {
    width: 285px;
  }
  @media screen and (min-width: 961px) and (max-width: 1280px) {
    width: 310px;
  }
`;
const FrameTop = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 61px;
`;
const TopLine = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 1px;
  width: calc(100% - 16px);
  background-color: #fff;
`;
const RightLine = styled.div`
  position: absolute;
  top: 14px;
  right: 2px;
  height: 43px;
  width: 1px;
  background-color: #fff;
`;
const TopDiagonalLine = styled.div`
  position: absolute;
  top: 0;
  right: 16px;
  height: 20px;
  width: 1px;
  transform: rotate(-45deg);
  transform-origin: top left;
  background-color: #fff;
`;
const FrameBottom = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 64px;
`;
const LeftLine = styled.div`
  position: absolute;
  bottom: 14px;
  left: 2px;
  height: 40px;
  width: 1px;
  background-color: #fff;
`;
const BottomLine = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  height: 1px;
  width: calc(100% - 16px);
  background-color: #fff;
`;
const BottomDiagonalLine = styled.div`
  position: absolute;
  bottom: 0;
  left: calc(16px - 20px);
  height: 1px;
  width: 20px;
  transform: rotate(45deg);
  transform-origin: bottom right;
  background-color: #fff;
`;
